//
//
//
//
//
//
import Vue from 'vue';
import { ACCESS_TOKEN } from '@/store/mutation-types';
export default {
  data: function data() {
    return {
      bastic: '../druids/druidloginOne.html?tk='
    };
  },
  created: function created() {
    this.bastic = this.bastic + Vue.ls.get(ACCESS_TOKEN);
  }
};